// extracted by mini-css-extract-plugin
export var emailContainer = "SignUpForm-module--emailContainer--ff0bd";
export var errorMessage = "SignUpForm-module--errorMessage--4563d";
export var formButton = "SignUpForm-module--formButton--1933c";
export var formContainer = "SignUpForm-module--formContainer--b60f5";
export var formContainerSignUp = "SignUpForm-module--formContainerSignUp--b86f8";
export var formCta = "SignUpForm-module--formCta--29c06";
export var formCtaSubtitle = "SignUpForm-module--formCtaSubtitle--e2310";
export var formCtaTitle = "SignUpForm-module--formCtaTitle--6c81b";
export var formForm = "SignUpForm-module--formForm--539ce";
export var formRight = "SignUpForm-module--formRight--5a57c";
export var formRightLink = "SignUpForm-module--formRightLink--89bb4";
export var formSelectContainer = "SignUpForm-module--formSelectContainer--f09e2";
export var formSpan = "SignUpForm-module--formSpan--98e6b";
export var signUpFormAlert = "SignUpForm-module--signUpFormAlert--5b6b1";